export default function () {
	return {
		showFullText: false,
		showButton: false,

		init() {
			this.$nextTick(() => {
				if (this.$refs.content.scrollHeight > this.$refs.content.clientHeight) {
					this.showButton = true
				}
			})
		},

		toggle() {
			this.showFullText = !this.showFullText
		},
	}
}
